import {FastRobotErrorcode, TrayType, ViewMode} from '../../constants/dataEnum';
import {changeView} from '../actions/appStateAction';
import createTrayRequirementChecker, {TrayCheckingEnum} from './TrayRequirementChecker';
import {showModalUnsupportedTray} from './commonModalBusiness';
// eslint-disable-next-line import/no-cycle
import {fastCommonActuatorAPIErrorHandler} from './errorHandlerBusiness';
import {isTouchProbeExpanded} from './instrumentBusiness';
import {checkIsTrayCalibrated, extendTouchProbe, gettingAndSetInstalledTray} from './trayCalibrationBusiness';
import {showMissingTrayModal, showTrayUncalibratedModal} from './trayModalBusiness';

export const checkTrayCalibrationData = (initialTrayId, newTrayData) => {
  const newTrayId = newTrayData?.tray?.id;
  const isCalibrated = checkIsTrayCalibrated(newTrayData);

  if (newTrayId !== initialTrayId && !isCalibrated) {
    return false;
  }

  return true;
};

export const checkTrayType = (newTrayData, requestedTrayType) => {
  const newTrayType = newTrayData?.tray?.trayType;

  if (requestedTrayType && newTrayType !== requestedTrayType) {
    return false;
  }

  return true;
};

/**
 * Check the installed tray suitability
 * @param {Function} callback failed callback
 * @param {TrayRequirementChecker} predefinedRequirementChecker permission checker object. if null will be generated automatically.
 */

export const checkAndHandleTraySuitability = (callback, predefinedRequirementChecker) => async (dispatch, getState) => {
  const {trayCalibrationState} = getState();
  const {id: trayId, isTrayAttached} = trayCalibrationState;

  const permissionChecker = predefinedRequirementChecker || (await dispatch(createTrayRequirementChecker()));

  const {isTouchProbeInitiallyExtended} = permissionChecker;
  const trayCheckingList = permissionChecker.getTrayCheckingList();
  const requestedTrayType = permissionChecker.getRequestedTrayType();

  let isPassed = true;

  const newTrayData = await dispatch(gettingAndSetInstalledTray());

  if (!isTrayAttached) {
    // outside of missing tray flow, this function is assumed to always be called when the instrument is idle, so dont need recovery
    dispatch(showMissingTrayModal(false, null, callback));
    return false;
  }

  // check tray type
  if (trayCheckingList.includes(TrayCheckingEnum.CHECK_TRAY_TYPE)) {
    isPassed = checkTrayType(newTrayData, requestedTrayType);

    if (!isPassed) {
      const isUseNormalCaddy = requestedTrayType === TrayType.NORMAL_CADDY;
      dispatch(showModalUnsupportedTray(isUseNormalCaddy, ViewMode.SETUP_WIZARD, callback));
      return false;
    }
  }

  // check tray calibration data
  if (trayCheckingList.includes(TrayCheckingEnum.CHECK_TRAY_CALIBRATION)) {
    isPassed = checkTrayCalibrationData(trayId, newTrayData);

    if (!isPassed) {
      const calibrateTrayCallback = () => {
        dispatch(changeView(ViewMode.TRAY_CALIBRATION));
      };

      dispatch(showTrayUncalibratedModal(calibrateTrayCallback, callback));
      return false;
    }
  }

  const isTouchProbeExtended = await dispatch(isTouchProbeExpanded());

  if (isTouchProbeInitiallyExtended && !isTouchProbeExtended) {
    await dispatch(extendTouchProbe(fastCommonActuatorAPIErrorHandler, false));
  }

  return true;
};

export function checkTrayReadiness() {
  return async (dispatch) => {
    const response = await dispatch(gettingAndSetInstalledTray());
    const {deckInserts} = response.tray || {};

    const isNoTrayAttached = !response?.result || !response.tray;
    const isNoTrayIdFound = response.tray?.id === 0;
    const isTrayUncalibrated = Boolean(deckInserts && deckInserts.find((deck) => !deck.isCalibrated));
    const isTrayReady = !isNoTrayAttached && !isNoTrayIdFound && !isTrayUncalibrated;

    let errorCode = FastRobotErrorcode.NoError;

    if (isNoTrayAttached) {
      errorCode = FastRobotErrorcode.MissingTray;
    } else if (isNoTrayIdFound) {
      errorCode = FastRobotErrorcode.NO_TRAY_ID_FOUND;
    } else if (isTrayUncalibrated) {
      errorCode = FastRobotErrorcode.TrayUncalibrated;
    }

    return {isNoTrayAttached, isNoTrayIdFound, isTrayUncalibrated, isTrayReady, errorCode};
  };
}
